import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'practice-template/:teamId/templates/create/new-pre-purchase',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/TemplatePrePurchaseContainer',
      './modules/TemplatePrePurchase'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const TemplatePrePurchase = require('./containers/TemplatePrePurchaseContainer').default
      const actions = require('./modules/TemplatePrePurchase')
      const reducer = require('./modules/TemplatePrePurchase').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'TemplatePrePurchaseCreation', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, TemplatePrePurchase)

    /* Webpack named bundle   */
    }, 'TemplatePrePurchaseCreation')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CreateTemplate/components/TemplateNewPrePurchase/index.js